/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'
import {useParams} from 'react-router-dom'
import DataTable from 'react-data-table-component'

const LimitROCHistoryModal = ({showMadalLimitROCHistory, setShowMadalLimitROCHistory}) => {
  const parameterId = useParams().parameterId
  const [limitData, setLimitData] = useState([])
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/parameters/${parameterId}/limit-roc-history`)

        setLimitData(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [showMadalLimitROCHistory])

  const closeModal = () => {
    setShowMadalLimitROCHistory(false)
  }

  const columns = [
    {
      name: 'Timestamp',
      selector: (row) => row.timestamp,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className='fs-9'>{getTimeFormat(row.timestamp)}</p>
          </>
        )
      },
    },

    {
      name: 'Min',
      selector: (row) => row.min,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className=''>{row.min}</p>
          </>
        )
      },
    },

    {
      name: 'Max',
      selector: (row) => row.max,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className=''>{row.max}</p>
          </>
        )
      },
    },
    {
      name: 'ROC',
      selector: (row) => row.roc,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className=''>{row.roc ? 'Enable' : 'Disable'}</p>
          </>
        )
      },
    },
    {
      name: 'User',
      selector: (row) => row.user,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p className='fs-9'>{row.user}</p>
          </>
        )
      },
    },
  ]

  return (
    <>
      <Modal show={showMadalLimitROCHistory} onHide={() => closeModal()} size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Limit ROC History</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            <div className='row'>
              <div className='card-body border-top py-3'>
                <div className='table-responsive' style={{borderRadius: '10px'}}>
                  <DataTable
                    columns={columns}
                    data={limitData}
                    pagination
                    paginationPerPage={25}
                    paginationRowsPerPageOptions={[25, 50, 100]}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary' onClick={() => closeModal()}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {LimitROCHistoryModal}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
